import { Check, Clock, Circle, X } from 'lucide-react';

export type StatusType = 
  | 'confirmed' 
  | 'pending' 
  | 'active' 
  | 'in-progress' 
  | 'noshow'
  | 'cancelled'
  | 'completed'
  | 'expired'
  | 'upcoming';

interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[11px]',
    md: 'px-3 py-1 text-xs'
  };
  
  const iconSize = size === 'sm' ? 12 : 14;
  
  const getStatusConfig = () => {
    switch (status) {
      case 'confirmed':
      case 'completed':
        return {
          bg: '#243E3D',
          text: '#FEFDFB',
          icon: <Check size={iconSize} strokeWidth={2.5} />,
          label: status === 'completed' ? 'Completada' : 'Confirmada'
        };
      case 'pending':
        return {
          bg: '#F59E0B',
          text: '#FEFDFB',
          icon: <Clock size={iconSize} strokeWidth={2.5} />,
          label: 'Pendiente'
        };
      case 'active':
      case 'in-progress':
        return {
          bg: status === 'in-progress' ? '#E07B54' : '#252E3E',
          text: '#FEFDFB',
          icon: <Circle size={iconSize} fill="currentColor" strokeWidth={0} className="animate-pulse" />,
          label: status === 'in-progress' ? 'Ahora' : 'Activa'
        };
      case 'upcoming':
        return {
          bg: '#EFA07E',
          text: '#243E3D',
          icon: <Clock size={iconSize} strokeWidth={2.5} />,
          label: 'Próxima'
        };
      case 'noshow':
        return {
          bg: '#EDEAE5',
          text: '#527A79',
          icon: <X size={iconSize} strokeWidth={2.5} />,
          label: 'No asistió'
        };
      case 'cancelled':
        return {
          bg: '#EDEAE5',
          text: '#527A79',
          icon: <X size={iconSize} strokeWidth={2.5} />,
          label: 'Cancelada'
        };
      case 'expired':
        return {
          bg: '#EDEAE5',
          text: '#527A79',
          icon: <Clock size={iconSize} strokeWidth={2.5} />,
          label: 'Expirada'
        };
      default:
        return {
          bg: '#EDEAE5',
          text: '#527A79',
          icon: null,
          label: status
        };
    }
  };
  
  const config = getStatusConfig();
  
  return (
    <span
      className={`inline-flex items-center gap-1 font-medium ${sizeClasses[size]}`}
      style={{
        backgroundColor: config.bg,
        color: config.text,
        borderRadius: '999px',
        fontFamily: 'var(--font-body)'
      }}
    >
      {config.icon}
      <span>{config.label}</span>
    </span>
  );
}
